import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  MenuItem,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useState } from "react";
import { AdditionalDocumentCategoryDTO } from "../../types/AdditionalDocumentCategoryDTO";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  categories: AdditionalDocumentCategoryDTO[];
  onClose: () => void;
  onSubmit: (data: {
    file: File;
    description: string;
    categoryCode: string;
    accountingCategory: boolean;
  }) => void;
  uploading?: boolean;
  error?: string | null;
};

export default function AddAdditionalDocumentModal({
  open,
  categories,
  onClose,
  onSubmit,
  uploading,
  error
}: Props) {
  const [file, setFile] = useState<File | null>(null);
  const [description, setDescription] = useState("");
  const [categoryCode, setCategoryCode] = useState("");
  const [accountingCategory, setAccountingCategory] = useState(false);

  const canSubmit = file && description && categoryCode;
  
  const { t } = useAppTranslation("common");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("Dodaj dokument")}</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
        {error && (
            <Typography color="error">
                {error}
            </Typography>
        )}

          {/* FILE */}
          <Button variant="outlined" component="label">
            {file ? file.name : t("Wybierz plik")}
            <input
              type="file"
              hidden
              onChange={(e) =>
                setFile(e.target.files?.[0] ?? null)
              }
            />
          </Button>

          {/* DESCRIPTION */}
          <TextField
            label={t("Opis")}
            value={description}
            required
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
          />

          {/* CATEGORY */}
          <TextField
            select
            label={t("Kategoria")}
            value={categoryCode}
            required
            onChange={(e) => setCategoryCode(e.target.value)}
            fullWidth
          >
            {categories.map((cat) => (
              <MenuItem key={cat.code} value={cat.code}>
                {cat.description}
              </MenuItem>
            ))}
          </TextField>
          <FormControlLabel
            control={
              <Checkbox
                checked={accountingCategory}
                onChange={(e) => setAccountingCategory(e.target.checked)}
              />
            }
            label={t("Kategoria księgowa")}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          {t("Anuluj")}
        </Button>
        <Button
            variant="contained"
            disabled={!canSubmit || uploading}
            onClick={() =>
                file &&
                onSubmit({
                  file,
                  description,
                  categoryCode,
                  accountingCategory,
                })
            }
            >
            {uploading ? t("Zapisywanie...") : t("Zapisz")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
